var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.5 16.2",
    style: {
      enableBackground: "new 0 0 15.5 16.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8,15.5H0.7c-0.4,0-0.7-0.3-0.7-0.7V12c0-1.2,0.8-2.3,1.9-2.6C3.1,9,4.9,8.5,7,8.5c0.4,0,0.7,0.3,0.7,0.7S7.4,9.8,7,9.8  c-1.9,0-3.6,0.4-4.7,0.8c-0.6,0.2-1,0.8-1,1.4v2.1h6.4c0.4,0,0.7,0.3,0.7,0.7S8.1,15.5,7.8,15.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7,9.8c-2.4,0-4.2-2.6-4.2-4.9V4.2C2.8,1.9,4.7,0,7,0c2.3,0,4.2,1.9,4.2,4.2v0.7C11.2,7.2,9.4,9.8,7,9.8z M7,1.3  c-1.6,0-2.9,1.3-2.9,2.9v0.7c0,1.6,1.3,3.6,2.9,3.6s2.9-2,2.9-3.6V4.2C9.9,2.6,8.6,1.3,7,1.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 7.8686929,12.562958 c -0.1414213,-0.141422 -0.1414213,-0.282843 -0.212132,-0.494975 0,-0.424264 0.2828427,-0.707107 0.6363961,-0.636396 h 5.939697 c 0.424264,0 0.707106,0.282842 0.636396,0.636396 0,0.424264 -0.282843,0.707107 -0.636396,0.636396 l -5.8689863,0.07071 C 8.1515356,12.704379 8.0101143,12.704379 7.8686929,12.562958 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.838541,15.532806 C 10.69712,15.391385 10.69712,15.249963 10.626409,15.037831 V 9.0981343 c 0,-0.424264 0.282843,-0.7071064 0.636396,-0.6363957 0.424264,0 0.707107,0.2828427 0.636396,0.6363957 v 5.9396967 c 0,0.424264 -0.282842,0.707107 -0.636396,0.636396 -0.07071,0.07071 -0.282843,0 -0.424264,-0.141421 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMember);
export default __webpack_public_path__ + "static/media/add_member.df5defb7a7ffa184f74ebac213754866.svg";
export { ForwardRef as ReactComponent };